import React from 'react';
import { StyledError } from '../GeneralInput/generalInput.style';
import { OptionalOutboundLink } from '../OptionalOutboundLink';
import { Nullable } from 'common/models/optional';

type Props = {
  tradeUrl?: Nullable<string>;
  inputError?: string;
  isLinkable: boolean;
};

export const InputError: React.FC<Props> = (props) => {
  if (!props.inputError) {
    return null;
  }

  if (props.tradeUrl && props.isLinkable) {
    return (
      <StyledError>
        <OptionalOutboundLink href={props.tradeUrl}>
          {props.inputError}
        </OptionalOutboundLink>
      </StyledError>
    );
  }

  return <StyledError>{props.inputError}</StyledError>;
};
